module.exports = __webpack_public_path__ + "static/img/ic_facebook.a30f1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/ic_facebook.png
// module id = I9S5
// module chunks = 10